<empty-page [config]="noPermissionPageConfig()"></empty-page>
